import {
  RouteObject,
  useRoutes
} from "react-router-dom";
import PageNotFound from './presentation/page-not-found';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { HomeFactory } from './presentation/home/home-factory';
import { PublicAccountFactory } from "./presentation/public-account/public-account-factory";
import { QuestionAwnserFactory } from "./presentation/question-awnser/question-awnser-factory";
import { OfficialDailyFactory } from "./presentation/official-daily/official-daily-factory";
import { OfficialDailyDetailFactory } from "./presentation/official-daily-detail/official-daily-detail-factory";
import { ManagedUnitFactory } from "./presentation/managed-unit/managed-unit-factory";
import { BiddingFactory } from "./presentation/bidding/bidding-factory";
import { BiddingDetailFactory } from "./presentation/bidding-detail/bidding-detail-factory";
import { NewsFactory } from "./presentation/news/news-factory";
import { NewsDetailFactory } from "./presentation/news-detail/news-detail-factory";
import { UsefulLinksFactory } from "./presentation/useful-links/useful-links-factory";
import { AuditsFactory } from "./presentation/audits/audits-factory";
import { AuditDetailFactory } from "./presentation/audits/audit-detail-factory";
import { GovernmentProjectsFactory } from "./presentation/government-projects/government-projects-factory";
import { GovernmentProjectDetailFactory } from "./presentation/government-projects/government-project-detail-factory";
import { PurchaseContractsFactory } from "./presentation/purchase-contracts/purchase-contracts-factory";
import { PurchaseContractDetailFactory } from "./presentation/purchase-contracts/purchase-contract-detail-factory";
import { PncpBiddingDetailFactory } from "./presentation/pncp-bidding-detail/pncp-bidding-detail-factory";
import { PncpPurchaseContractDetailFactory } from "./presentation/pncp-purchase-contract-detail/pncp-purchase-contract-detail-factory";
import { AgreementsFactory } from "./presentation/agreements/agreements-factory";
import { AgreementDetailFactory } from "./presentation/agreements/agreement-detail-factory";
import { ContactFactory } from "./presentation/contact/contact-factory";
import { CityInfoFactory } from "./presentation/city-info/city-info-factory";
import AccessibilityFactory from "./presentation/accessibility/accessibility-factory";
import SiteMapFactory from "./presentation/site-map/site-map-factory";
import { SearchResultsFactory } from "./presentation/search-results/search-results-factory";
import ScrollToTop from "./components/ScrollToTop";
import BackToTopButton from "./presentation/components/layout/back-to-top-button";
import { PublicationsFactory } from "./presentation/publications/publications-factory";
import { PublicationDetailFactory } from "./presentation/publications/publication-detail-factory";
import { CustomPageFactory, LegacyCustomPageFactory } from "./presentation/custom-page/custom-page-factory";

const defaultRoutes = (): RouteObject[] => {
  var routes: RouteObject[] = [
    // Rotas standalone (sem state/city)
    {
      path: "/", element: <HomeFactory />
    },
    {
      path: "/home", element: <HomeFactory />
    },
    {
      path: "/noticias", element: <NewsFactory />
    },
    {
      path: "/noticia/:id", element: <NewsDetailFactory />
    },
    {
      path: "/contas-publicas/:categoryId?/:subcategoryId?", element: <PublicAccountFactory />
    },
    {
      path: "/diario-oficial/:year?", element: <OfficialDailyFactory />
    },
    {
      path: "/diario-oficial/detalhes/:id", element: <OfficialDailyDetailFactory />
    },
    {
      path: "/publicacoes/:categoryId?/:subcategoryId?", element: <PublicationsFactory />
    },
    {
      path: "/publicacoes/detalhes/:id", element: <PublicationDetailFactory />
    },
    {
      path: "/perguntas-respostas", element: <QuestionAwnserFactory />
    },
    {
      path: "/estrutura-administrativa", element: <ManagedUnitFactory />
    },
    {
      path: "/licitacoes", element: <BiddingFactory />
    },
    {
      path: "/licitacoes/:id", element: <BiddingDetailFactory />
    },
    {
      path: "/licitacoes/pncp/:id", element: <PncpBiddingDetailFactory />
    },
    {
      path: "/links-uteis", element: <UsefulLinksFactory />
    },
    {
      path: "/auditoria", element: <AuditsFactory />
    },
    {
      path: "/auditoria/:id", element: <AuditDetailFactory />
    },
    {
      path: "/projetos-governamentais", element: <GovernmentProjectsFactory />
    },
    {
      path: "/projetos-governamentais/:id", element: <GovernmentProjectDetailFactory />
    },
    {
      path: "/contratos-aquisicoes", element: <PurchaseContractsFactory />
    },
    {
      path: "/contratos-aquisicoes/:id", element: <PurchaseContractDetailFactory />
    },
    {
      path: "/contratos-aquisicoes/pncp/:id", element: <PncpPurchaseContractDetailFactory />
    },
    {
      path: "/convenios-repasses", element: <AgreementsFactory />
    },
    {
      path: "/convenios-repasses/:id", element: <AgreementDetailFactory />
    },
    {
      path: "/contato", element: <ContactFactory />
    },
    {
      path: "/a-cidade", element: <CityInfoFactory />
    },
    {
      path: "/acessibilidade", element: <AccessibilityFactory />
    },
    {
      path: "/mapa-do-site", element: <SiteMapFactory />
    },
    {
      path: "/busca", element: <SearchResultsFactory />
    },
    {
      path: "/pagina-customizada/:slug", element: <LegacyCustomPageFactory />
    },
    // Página customizada do APM: "/pagina/{slug}"
    {
      path: "/pagina/:slug", element: <CustomPageFactory />
    },

    // Rotas com parâmetros dinâmicos para sub-app (/:state/:city/...)
    // Exemplo: /ba/pmjoaodourado/home
    {
      path: "/:state/:city",
      children: [
        {
          path: "", element: <HomeFactory />
        },
        {
          path: "home", element: <HomeFactory />
        },
        {
          path: "noticias", element: <NewsFactory />
        },
        {
          path: "noticia/:id", element: <NewsDetailFactory />
        },
        {
          path: "contas-publicas/:categoryId?/:subcategoryId?", element: <PublicAccountFactory />
        },
        {
          path: "diario-oficial/:year?", element: <OfficialDailyFactory />
        },
        {
          path: "diario-oficial/detalhes/:id", element: <OfficialDailyDetailFactory />
        },
        {
          path: "publicacoes/:categoryId?/:subcategoryId?", element: <PublicationsFactory />
        },
        {
          path: "publicacoes/detalhes/:id", element: <PublicationDetailFactory />
        },
        {
          path: "perguntas-respostas", element: <QuestionAwnserFactory />
        },
        {
          path: "estrutura-administrativa", element: <ManagedUnitFactory />
        },
        {
          path: "licitacoes", element: <BiddingFactory />
        },
        {
          path: "licitacoes/:id", element: <BiddingDetailFactory />
        },
        {
          path: "licitacoes/pncp/:id", element: <PncpBiddingDetailFactory />
        },
        {
          path: "links-uteis", element: <UsefulLinksFactory />
        },
        {
          path: "auditoria", element: <AuditsFactory />
        },
        {
          path: "auditoria/:id", element: <AuditDetailFactory />
        },
        {
          path: "projetos-governamentais", element: <GovernmentProjectsFactory />
        },
        {
          path: "projetos-governamentais/:id", element: <GovernmentProjectDetailFactory />
        },
        {
          path: "contratos-aquisicoes", element: <PurchaseContractsFactory />
        },
        {
          path: "contratos-aquisicoes/:id", element: <PurchaseContractDetailFactory />
        },
        {
          path: "contratos-aquisicoes/pncp/:id", element: <PncpPurchaseContractDetailFactory />
        },
        {
          path: "convenios-repasses", element: <AgreementsFactory />
        },
        {
          path: "convenios-repasses/:id", element: <AgreementDetailFactory />
        },
        {
          path: "contato", element: <ContactFactory />
        },
        {
          path: "a-cidade", element: <CityInfoFactory />
        },
        {
          path: "acessibilidade", element: <AccessibilityFactory />
        },
        {
          path: "mapa-do-site", element: <SiteMapFactory />
        },
        {
          path: "busca", element: <SearchResultsFactory />
        },
        {
          path: "pagina-customizada/:slug", element: <LegacyCustomPageFactory />
        },
        {
          path: "pagina/:slug", element: <CustomPageFactory />
        },
      ]
    },

    // 404 - deve ser a última rota
    {
      path: "*", element: <PageNotFound />
    },
  ];

  return routes;
}

function App() {

  let routes = useRoutes(
    defaultRoutes()
  );
  return (
    <>
      <ScrollToTop />
      {routes}
      <BackToTopButton />
    </>
  );
}

export default App;
library.add(fas);
